import { render, staticRenderFns } from "./TaskHeader.vue?vue&type=template&id=f72a3de8&scoped=true"
import script from "./TaskHeader.vue?vue&type=script&lang=js"
export * from "./TaskHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskHeader.vue?vue&type=style&index=0&id=f72a3de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a3de8",
  null
  
)

export default component.exports